import * as ActionType from '../constants/ActionType'

export const initialState = {
    'config': null,
    'organisationUsers': null
};

function app(state = initialState, action) {
    switch (action.type) {

        case ActionType.RECEIVE_APP_CONFIG:
            const appConfig = action.payload.configuration;
            return {
                ...state,
                config: appConfig
            };

        case ActionType.RECEIVE_ORGANISATION_USERS:
            const users = action.payload;
            return {
              ...state,
              organisationUsers: users
            };

        default:
            return state
    }
}

export default app;


// WEBPACK FOOTER //
// ./src/js/reducers/app.js